import ResizeHandler from "./resize-handler";
import Toggles from "./toggles";
import {disableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock/lib/bodyScrollLock.es6';
import ScrollHandler from "./scroll-handler";

export default class Search {
    constructor(breakpoint, searchContainerSelector) {
        this.breakpoint = breakpoint;
        this.searchContainerSelector = searchContainerSelector;
        this.searchContainerNode = document.querySelector(this.searchContainerSelector);

        this.setBodyOverflow = this.setBodyOverflow.bind(this);
        this.setFocus = this.setFocus.bind(this);

        this.setToggles();
        this.setResizeHandlers();
    }

    setToggles() {
        new Toggles([
                {
                    selector: '.toggle.search, .error404 .button.-search',
                    triggers: 'click',
                    affectedOthers: this.searchContainerSelector,
                    removeClass: 'no-transition',
                    callback: this.setFocus,
                    toggleClass: '-open',
                },
                {
                    selector: '.toggle.search',
                    triggers: 'click',
                    callback: this.setBodyOverflow
                },
                {
                    selector: '.toggle.menu',
                    triggers: 'click',
                    affectedOthers: this.searchContainerSelector,
                    removeClass: '-open',
                },
                {
                    selector: '.toggle.search',
                    triggers: 'click',
                    callback: this.setFocus,
                },
                {
                    selector: '.toggle.menu',
                    triggers: 'click',
                    affectedOthers: '.toggle.search',
                    removeClass: '-active',
                },
            ]
        );
    }

    setFocus(){
        let searchContainer = this.searchContainerNode;
        let searchInput = searchContainer.querySelector('#s');

        if(!searchInput){
            return;
        }

        searchInput.focus();
    }

    setResizeHandlers() {
        new ResizeHandler([
            // remove transition of search when window is resized from mobile to desktop width
            {
                width: this.breakpoint,
                selector: this.searchContainerSelector,
                addClass: 'no-transition',
            },
            // remove transition of search container when window is resized from desktop to mobile width
            {
                width: this.breakpoint,
                selector: this.searchContainerSelector,
                addClass: 'no-transition',
                evaluateInitial: false,
                direction: 'down'
            }
        ]);
    }

    setBodyOverflow(toggleNode) {
        if (window.innerWidth > this.breakpoint) {
            return;
        }

        if (toggleNode.classList.contains('-active')) {
            ScrollHandler.disableDocumentScroll(this.searchContainerNode);
        } else {
            ScrollHandler.enableDocumentScroll();
        }
    }
}